import { SearchBarVariant } from "./search-bar";

export enum DropdownFilterVariant {
    PrimaryGrey800 = "primaryGrey800",
    PrimaryBlack900 = "primaryBlack900",
    SecondaryGrey800 = "secondaryGrey800",
    SecondaryBlack900 = "secondaryBlack900",
}

export enum SortingFilterEnum {
    MostRecent = "descending",
    LeastRecent = "ascending",
}

//this function works for both DropdownVariant and SearchBarVariant
export const calculateIsPrimaryVariant = (variant: DropdownFilterVariant | SearchBarVariant) => {
    if (Object.values(DropdownFilterVariant).includes(variant as DropdownFilterVariant)) {
        return (
            variant === DropdownFilterVariant.PrimaryGrey800 ||
            variant === DropdownFilterVariant.PrimaryBlack900
        );
    } else if (Object.values(SearchBarVariant).includes(variant as SearchBarVariant)) {
        return (
            variant === SearchBarVariant.PrimaryGrey800 ||
            variant === SearchBarVariant.PrimaryBlack900
        );
    }
};

//this function works for both DropdownVariant and SearchBarVariant
export const calculateIsGrey800Variant = (variant: DropdownFilterVariant | SearchBarVariant) => {
    if (Object.values(DropdownFilterVariant).includes(variant as DropdownFilterVariant)) {
        return (
            variant === DropdownFilterVariant.PrimaryGrey800 ||
            variant === DropdownFilterVariant.SecondaryGrey800
        );
    } else if (Object.values(SearchBarVariant).includes(variant as SearchBarVariant)) {
        return (
            variant === SearchBarVariant.PrimaryGrey800 ||
            variant === SearchBarVariant.SecondaryGrey800
        );
    }
};
